import BlogEntry from "./blog-entry"

function HowTo () {
  return (<>
    <BlogEntry>
      <div className="blog-post">
        <h1>Preparation before using JNFT platform</h1>
        <div className="fullvideo">
          <div className="_title">
            1. Install MetaMask extension on Google Chrome
          </div>
          <iframe
            src="https://www.youtube.com/embed/AR6-4YucKkw"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="fullvideo">
          <div className="_title">
            2. Add BSC Testnet network to MetaMask
          </div>
          <iframe
            src="https://www.youtube.com/embed/PbBevcP0mzU"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="fullvideo">
          <div className="_title">
            3. Get free BNB
          </div>
          <iframe
            src="https://www.youtube.com/embed/lSj44Oyw-gs"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="fullvideo">
          <div className="_title">
            4. Get free fJFIN
          </div>
          <iframe
            src="https://www.youtube.com/embed/iUvifGGvpwE"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="fullvideo">
          <div className="_title">
            5. Add fJFIN token to MetaMask wallet
          </div>
          <iframe
            src="https://www.youtube.com/embed/_tThhfgfM6E"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div>
        

        2 Get Free BNB
        1ให้คุณเข้าไปที่เว็บไซต์ https://testnet.venus.io/faucet 

        2 หน้าต่าง Metamask ของคุณจะเด้งขึ้นมา ให้คุณทำคลิกไปที่ Next  และกด Connect เพื่อเชื่อมต่อกับกระเป๋า Metamask ของคุณเข้ากับระบบ



        3 จากนั้นให้คุณคัดลอก address ของกระเป๋าคุณมาใส่ไว้ในช่อง




        4 ให้คุณเลือกกด give me BNB ซึ่งจะมีให้เลือกทั้ง 1 BNB , 2.5 BNB , 5 BNB ให้เลือกจำนวนเหรียญที่คุณต้องการ หลังจากนั้นให้เข้าไปเช็คที่กระเป๋า Metamask ของคุณ จะพบว่าเหรียญได้เข้าไปอยู่ในกระเป๋าของคุณเรียบร้อย 

        3 Get Free fJFIN 
        1 ให้คุณเข้าไปที่เว็บไซต์ demo.jnft.digital 


        2 คุณจะเห็นหน้าเว็บไซต์ JNFT ที่มุมด้านขวาบนจะขึ้นคำว่า Connect Wallet ให้คุณกดคลิกเข้าไป



        3 จากนั้นทางด้านซ้ายของเว็บไซต์จะขึ้นคำว่า Get Free fJFIN ให้คุณกดคลิก


        4 หลังจากที่คุณกดคลิก หน้าต่างของ Metamask จะปรากฎให้คุณเสียค่า Gas จากนั้นให้คุณกด Confirm  



        5 ให้คุณเข้าไปที่ Metamask ในช่องของ Activity จะมี contract interaction ขึ้นมา ให้กดคลิก และกดเครื่องหมายลูกศรที่มุมขวาบน


        6  หน้าต่างของเว็บจะขึ้นมา ให้คุณคัดลอก address ที่ช่องของ Interacted With (To) 





        7   ให้เข้าไปที่ Metamask กดไปที่ช่องของ Assets  ด้านล่างจะมีปุ่มให้กดคลิกที่  Add Tokens 



        8    จากนั้นนำ Address ที่ได้ทำการคัดลอกไว้มาวาง และกด Next จากนั้นคลิกที่ Add Tokens เหรียญของ fJIN ก็จะเข้ามาที่กระเป๋าของคุณ




        </div>
      </div>
    </BlogEntry>
  </>)
}

export { HowTo }
export default HowTo
